//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/Routing.js";
let d=[[[1,"SegmentCollector",0,"Routing.RouteObjectCollector",0]],[[[],"AnalyzeBending",{},0,0],[["selectedStock"],"SetStockData",{},1,0],[["selectedStockHolder"],"SetStockDataFromLibrary",{},1,0],[["elbowSelected","index"],"FillBendMachine",{},2,0],[["rtsSelected"],"SetRtsSelected",{},1,0],[["newSelection"],"SetNewSelection",{},1,0],[["partNumberId"],"SetPartNumberIdentifier",{},1,0],[["classificationId"],"SetClassificationId",{},1,0]],[]];
SPLM.MechanicalRouting.PipeBendAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.PipeBendAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;